import { useTranslation } from 'react-i18next';

import { GridColDef } from '@mui/x-data-grid-pro';

export const useFixedColumns = () => {
  const { t } = useTranslation('common');
  return [
    {
      field: 'code',
      hideable: false,
      headerName: t('code'),
      flex: 1
    },
    {
      field: 'name',
      hideable: false,
      headerName: t('name'),
      flex: 1
    },
    {
      field: 'description',
      headerName: t('description'),
      flex: 1
    }
  ] as GridColDef[];
};
